import styled from '@emotion/styled';

import { StyledFlex } from '@shared/styles/styled';

export const StyledInfoList = styled(StyledFlex)`
  width: 100%;
`;

export const StyledInfoListGroup = styled('div', {
  shouldForwardProp: (prop) => prop !== 'noPaddings',
})`
  width: 100%;

  ${({ noPaddings }) =>
    !noPaddings &&
    `
    &:not(:last-child) {
      padding-bottom: 30px;
      margin-bottom: 40px;
    }
    
    &  & {
      padding: 30px 0 0 0 !important;
      border-bottom: none !important;
      margin-bottom: 0 !important;
    }
  `};
`;

export const StyledInfoListTitle = styled.div`
  padding: 0 14px;
  margin-bottom: 18px;
`;

export const StyledInfoListItems = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledInfoListItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: ${({ p }) => p || '14px'};
  min-height: 50px;
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.dividerColor};
  }
`;

export const StyledInfoListItemKey = styled('div', {
  shouldForwardProp: (prop) => !['overflowWrap'].includes(prop),
})`
  max-width: 40%;
  text-align: left;
  flex: 1 1;
  word-break: break-all;
  ${({ overflowWrap }) => overflowWrap && 'overflow-wrap: anywhere;'};
`;

export const StyledInfoListItemValue = styled('div', {
  shouldForwardProp: (prop) => !['overflowWrap'].includes(prop),
})`
  flex: 1 1;
  word-break: ${({ wordBreak }) => wordBreak || 'break-all'};
  display: flex;
  justify-content: flex-end;
  position: ${({ isLoading }) => (isLoading ? 'relative' : 'unset')};
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'normal')};
  overflow: ${({ hideOverflow }) => (hideOverflow ? 'hidden' : 'visible')};
  ${({ overflowWrap }) => overflowWrap && 'overflow-wrap: anywhere;'};
`;
